import { IBaseDtoType } from './common.type'

export interface IRewardPointsPayload {
  scans_to_complete?: number
}

export interface IRewardPointsBase {
  type: ERewardPointsTypes
  amount: number
  default: boolean
  name: string
  description: string
  payload: IRewardPointsPayload | null
}

export interface IRewardPointsBaseWithId extends IRewardPointsBase, IBaseDtoType {}

export interface IRewardPointsForm {
  type: ERewardPointsTypes
  amount: number
  default: boolean
  name: string
  description: string
  scans_to_complete?: number
}

export interface IUpdateRewardPointsDto extends IRewardPointsForm {}

export interface IUpdateRewardPointsDtoWithId extends IRewardPointsForm {
  id: string
}

export interface ICreateRewardPointsDto extends IRewardPointsForm {}

export interface IRewardPointsRespDto {
  count: number
  data: IRewardPointsBaseWithId[]
}

export interface IScanToEarnGetPriceRespDto {
  amount: number
}

export enum ERewardPointsTypes {
  SCAN_TO_EARN = 'scan-to-earn',
  REFERRAL_PROGRAM = 'referral_program',
  USER_SIGNUP = 'user_signup',
  WALLET_CONNECT = 'wallet_connect',
  TRAI_IN_WALLET = 'trai_in_wallet',
  SPECIAL_1 = 'special_1',
  SPECIAL_2 = 'special_2',
  SPECIAL_3 = 'special_3',
  SPECIAL_4 = 'special_4',
  SPECIAL_5 = 'special_5',
  SPECIAL_6 = 'special_6',
  SPECIAL_7 = 'special_7',
  SPECIAL_8 = 'special_8',
  SPECIAL_9 = 'special_9',
  SPECIAL_10 = 'special_10',
  SPECIAL_11 = 'special_11',
  SPECIAL_12 = 'special_12',
  SPECIAL_13 = 'special_13',
  SPECIAL_14 = 'special_14',
  SPECIAL_15 = 'special_15',
  SPECIAL_16 = 'special_16',
  SPECIAL_17 = 'special_17',
  SPECIAL_18 = 'special_18',
  SPECIAL_19 = 'special_19',
  SPECIAL_20 = 'special_20',
  TRAI_RECEIVED = 'trai_received',
}
